import {baseRequestService} from "../base.ts";
import {CalendarEvent} from "../../types/domain.ts";

export const eventsCalendarGet = () => baseRequestService<CalendarEvent[]>({
    url: '/events/calendar',
    method: 'GET'
})